import { render, staticRenderFns } from "./UdiDigitization.vue?vue&type=template&id=faa95eee&scoped=true"
import script from "./UdiDigitization.vue?vue&type=script&lang=js"
export * from "./UdiDigitization.vue?vue&type=script&lang=js"
import style0 from "./UdiDigitization.vue?vue&type=style&index=0&id=faa95eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_n4a2vfauuuf6vmcvyn2rbj6bo4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa95eee",
  null
  
)

export default component.exports